import { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';
import Image from '@/components/common/Image';

interface Investor {
  name: string;
  logo: string;
}

interface InvestorsProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description: string;
  investors: Investor[];
}

export const Investors = ({
  title,
  description,
  investors,
  className,
  ...props
}: InvestorsProps) => {
  return (
    <section className={cn('py-20 bg-gray-50', className)} {...props}>
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{title}</h2>
          <p className="text-xl text-gray-600">{description}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {investors.map((investor, index) => (
            <div
              key={index}
              className=" rounded-lg p-8 flex items-center justify-center"
            >
              <Image
                src={investor.logo}
                alt={investor.name}
                style={{ objectFit: 'contain', width: '100%', height: '100%' }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};